import { Component, Input, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { AuthenticationService } from "@app/core";
import {
  BaseControl,
  ColumnaMaestra,
  EstructuraEspecifica,
  FiltroTableMasterGeneral,
  InformacionTablaMaestra,
  Static,
  TablaMaestra,
  Valores,
  ValoresEspecificos,
  Option,
  Login,
  ModalTableComponent,
  ButtonsModalTable,
  Const,
} from "@app/shared";
import { find, indexOf, update, Partial } from "lodash";
import { LocalDataSource } from "ng2-smart-table";
import { ToastrService } from "ngx-toastr";
import { SystemUsersConfigServcie } from "./shared/system-users.config.service";
import { SystemUsuersDataService } from "./shared/system-users.data.service";
import { SystemUsersFormService } from "./shared/system-users.form.service";
import { environment } from "@env/environment";
import { DatePipe } from "@angular/common";

@Component({
  selector: "iw-system-users",
  templateUrl: "./system-users.component.html",
  styleUrls: ["./system-users.component.scss"],
  providers: [SystemUsuersDataService, SystemUsersFormService, DatePipe],
})
export class SystemUsersComponent implements OnInit {
  // Informacion de el login del usuario
  @Input() userLogin: Login;
  //Define si mostrar la vista inicial o los formularios
  formOpen = false;
  // Datos para llenar la tabla
  sourceData: LocalDataSource = new LocalDataSource();
  // Usuarios sin login para llenar la tabla
  usersNoLogin: LocalDataSource = new LocalDataSource();
  // Configuracion de la tabla
  settings = {};
  // Configuraciones de la seguda tabla
  settingsUsers = {};
  // Define los tipos de permisos que tiene el usuario en sesión
  activateAction = {
    created: false,
    review: false,
    update: false,
    delete: false,
    estructure: false,
    createUserSystem: false,
    reviewUserSystem: false,
    updateUserSystem: false,
    deleteUserSystem: false,
    buildStructure: false,
    reviewStructure: false,
    deleteStructure: false,
  };
  // Tablas maestras
  tablesMaster: Array<TablaMaestra> = [];
  // Define la opcion de la tabla maestra seleccionada
  opcion = "";
  // Define si la tabla seleccionada es una dinamica
  dynamicMasterTable = true;
  // Accion que se esta realizando
  actionRow = "Agregar";
  // Define el nombre de la tabla maestra a la que se le desea realizar la accion de modificar o actualizar
  masterTable = "";
  // Clase base de los controles del formulario dinamico
  controls: BaseControl<any>[] = [];
  // Define cuando se realiza una accion a una maestra dinamica
  actionMaster = false;
  // Define si la accion a realizar es modificar o actualizar
  modificar = false;
  // Contiene el registro seleccionado de la tabla
  registroSeleccionado: any;
  // Tabla maestra seleccionada
  tableSelect: TablaMaestra;
  // Contiene la estructura de la maestra
  structureMaster: Array<ColumnaMaestra> = [];
  // Contiene el formulario renderizado
  currentForm: FormGroup;
  // Contiene los templetes de los campos personalizados del formulario
  templatesFomr = {};
  // tipos de usuarios para el selector
  usersType: any[] = [
    { id: 1, nombre: "Usuario nuevo" },
    { id: 2, nombre: "Usuario existente" },
  ];
  // model para el selector de tipos de usuarios
  typeUserModel: any = null;
  // Define cuándo mostrar el formulario de acción sobre la tabla
  activateFormTable = false;
  // define cuando se está cargando la tabla inicial
  loading = false;
  // opciones de los grupos
  optRoles: Array<Option> = [];
  // Contiene las opciones de los formularios de creacion o edicion de el login
  options = {};
  // opciones de las empresas
  optCompanies: Array<Option> = [];

  // opciones de las empresas
  optCharges: Array<Option> = [];
  // opciones de las sedes
  optSedes: Array<Option> = [];
  // Contiene temporalmente la empresa seleccionada
  tmpCompany = -1;
  // Define la pregunta del modal de la tabla
  questionTable = "";
  // Contiene los botones que apareceran en la modal de la tabla
  buttons: Array<ButtonsModalTable> = [];
  // Define la clase del boton de los formularios
  claseButton = '';
  // Define el texto de el boton submit de los formularios
  textoButton = '';
  // define si el selector está desabilitado
  disableSelect: boolean = false;
  // almacenará los datos del usuario clickeado
  dataUserSelected: any;


  // referencia al usuario seleccionado en la segunda tabla
  userSelected: any = false;
  // Guarda valor de la accion sobre la modal
  respAction: any;
  // Identificador de usuario nuevo/existente
  isNew: boolean = false;
  // Identificador de usuario
  userID: number;
  // Identificador de maestra
  id_maestra: number;
  // nombre usuario login automatico
  userName: string;
  // apellido usuario login automatico
  lastName: string;
  // Variable de verificacion para login automatico
  generateUserLogin: boolean = environment.generateUserLogin;
  name: string = '';
  modifiedUser: Boolean = false;
  // Identificador de permisos para las pestañas diferentes de usuarios
  tabsGroupPermisionUser: boolean = true;

  @Input() childProperty: string;
  // Referencia a la plantilla para el control personalizado de ng-select
  @ViewChild("ngSelect") ngSelectTpl: TemplateRef<any>;
  // Referencia a la plantilla para el control personalizado de multiselect
  @ViewChild("ngTplMultiSelect") ngMultiSelect: TemplateRef<any>;
  // Referencia al componente de el modal de acciones de la tabla
  @ViewChild("modalTable") private modalTable: ModalTableComponent;

  constructor(
    private suds: SystemUsuersDataService,
    private sufs: SystemUsersFormService,
    private toastr: ToastrService,
    private as: AuthenticationService,
    private datePipe: DatePipe
  ) { }

  async ngOnInit() {
    this.templatesFomr = {
      ngSelectTpl: this.ngSelectTpl,
      multiSelect: this.ngMultiSelect,
    };
    this.activateAction.review = this.as.confirmPermission(
      Const.types_permissions.administrationGroupsPermissions,
      Const.types_action_permissions.reviewUser,
    );
    // Validacion de permisos sobre el tabs diferente de usuarios
    this.tabsGroupPermisionUser = this.as.confirmPermission(
      Const.types_permissions.administrationGroupsPermissions,
      Const.types_action_permissions.review,
    );
    if (this.activateAction.review == true && this.tabsGroupPermisionUser == false) {
      this.startConsulting();
    }
    /*this.activateAction.review = this.as.confirmPermission(
      Const.types_permissions.administrationMasterTables,
      Const.types_action_permissions.reviewUserSystem,
    );
    this.activateAction.review = false;
    if (this.activateAction.review) {
      
      this.suds.getMasterTables().subscribe((data) => {
        this.tablesMaster = data;
        this.tablesMaster.sort((a, b) => a.id - b.id);
        this.opcion = "Usuarios";
      });
      this.suds.getRoles().subscribe((data) => {
        if (data && data.length) {
          data.forEach((rol) => {
            this.optRoles.push({
              key: rol.id,
              value: rol.nombre,
            });
          });
          this.options["optionRoles"] = this.optRoles;
        }
      });
      this.suds.getCompanies().subscribe((data) => {
        if (data && data.length) {
          data.sort((a, b) => a.id - b.id);
          data.forEach((rol) => {
            this.optCompanies.push({
              value: rol.id,
              key: rol.nombre,
            });
          });
          this.options["optCompanies"] = this.optCompanies;
        }
      });
      //Setea valores de sedes al selector
      // this.suds.getSedes(this.optCompanies[0].value).subscribe((data) => {
      //   console.log(data);
        
      //   if (data && data.length) {
      //     data.sort((a, b) => a.id - b.id);
      //     data.forEach((rol) => {
      //       this.optSedes.push({
      //         value: rol.id,
      //         key: rol.nombre,
      //       });
      //     });
      //     this.options["optSedes"] = this.optSedes;
      //   }
      // });

      
      // FIN

      this.suds.getCharges().subscribe((data) => {
        if (data && data.length) {
          data.sort((a, b) => a.id - b.id);
          data.forEach((rol) => {
            this.optCharges.push({
              value: rol.id,
              key: rol.nombre,
            });
          });
          this.options["optCharges"] = this.optCharges;
        }
      });

      //peticion de usuarios
      // const configTable = new SystemUsersConfigServcie();
      // this.sourceData.empty();
      // this.usersNoLogin.empty();
      // this.loading = true;
      // const master = await this.suds.getInformacionUserMasterTable();
      // //const master_users_not_login = await this.suds.getInformacionUserWithoutLoginMasterTable();
      // this.loading = false;
      // master.valores.sort((a, b) => a.id - b.id);
      // //master_users_not_login.valores.sort((a, b) => a.id - b.id);
      // if (master.estructura.length) {
      //   this.structureMaster = master.estructura;
      //   this.settings = configTable.getDynamicColumns(this.structureMaster, false);
      //   await this.asyncForEach(master.estructura, async (field: ColumnaMaestra) => {
      //     await this.loadingSelectsTablePrincipal(field, master);
      //   });
      // }
      // this.id_maestra = master.id;
      // this.setTables(master.valores,false);
      //this.setTables(master_users_not_login.valores,true);
      //FIN


      this.buttons = [];
      this.activateAction.delete = this.as.confirmPermission(
        Const.types_permissions.administrationMasterTables,
        Const.types_action_permissions.deleteUserSystem,
      );
      this.activateAction.createUserSystem = this.as.confirmPermission(
        Const.types_permissions.administrationMasterTables,
        Const.types_action_permissions.createUserSystem,
      );
      this.activateAction.update = this.as.confirmPermission(
        Const.types_permissions.administrationMasterTables,
        Const.types_action_permissions.updateUserSystem,
      );
      if (this.activateAction.update) {
        this.buttons.push({ label: "Modificar", class: "btn-warning", value: "modificar" });
      }
      if (this.activateAction.delete) {
        this.buttons.push({ label: "Eliminar", class: "btn-danger", value: "eliminar" });
      }
      // this.buttons.push({ label: "Usuario del sistema", class: "btn-info", value: "login" });
      this.buttons.push({ label: "Cancelar", value: "cancelar" });
    }else{
      this.toastr.warning('Usted no posee los permisos necesarios para ver los usuarios del sistema', 'Error en la acción')
    }*/
  }

  async startConsulting() {
    // Validacion de permisos
    this.validatePermissions();

    const configTable = new SystemUsersConfigServcie();
    this.sourceData.empty();
    this.usersNoLogin.empty();
    this.loading = true;
    const master = await this.suds.getInformacionUserMasterTable();
    this.loading = false;
    master.valores.sort((a, b) => a.id - b.id);
    if (master.estructura.length) {
      this.structureMaster = master.estructura;
      this.settings = configTable.getDynamicColumns(this.structureMaster, false, false, true);
      await this.asyncForEach(master.estructura, async (field: ColumnaMaestra) => {
        await this.loadingSelectsTablePrincipal(field, master);
      });
    }
    this.id_maestra = master.id;
    this.setTables(master.valores, false, true);
  }

  validatePermissions() {
    this.activateAction.review = this.as.confirmPermission(
      Const.types_permissions.administrationGroupsPermissions,
      Const.types_action_permissions.reviewUser,
    );
    if (this.activateAction.review) {

      this.suds.getMasterTables().subscribe((data) => {
        this.tablesMaster = data;
        this.tablesMaster.sort((a, b) => a.id - b.id);
        this.opcion = "Usuarios";
      });
      if (this.optRoles && this.optRoles.length) {
        this.optRoles = [];
      }
      this.suds.getRoles().subscribe((data) => {
        if (data && data.length) {
          data.forEach((rol) => {
            this.optRoles.push({
              key: rol.id,
              value: rol.nombre,
            });
          });
          this.options["optionRoles"] = this.optRoles;
        }
      });
      if (this.optCompanies && this.optCompanies.length) {
        this.optCompanies = [];
      }
      this.suds.getCompanies().subscribe((data) => {
        if (data && data.length) {
          data.sort((a, b) => a.id - b.id);
          data.forEach((rol) => {
            this.optCompanies.push({
              value: rol.id,
              key: rol.nombre,
            });
          });
          this.options["optCompanies"] = this.optCompanies;
        }
      });
      if (this.optCharges && this.optCharges.length) {
        this.optCharges = [];
      }
      this.suds.getCharges().subscribe((data) => {
        if (data && data.length) {
          data.sort((a, b) => a.id - b.id);
          data.forEach((rol) => {
            this.optCharges.push({
              value: rol.id,
              key: rol.codigo ? rol.nombre + " - " + rol.codigo : rol.nombre,
              others: rol.fecha_contrato, // Se pasa el valor de la columna fecha_contrato
            });
          });
          this.options["optCharges"] = this.optCharges;
        }
      });

      this.buttons = [];
      this.activateAction.delete = this.as.confirmPermission(
        Const.types_permissions.administrationGroupsPermissions,
        Const.types_action_permissions.deleteUser,
      );
      this.activateAction.createUserSystem = this.as.confirmPermission(
        Const.types_permissions.administrationGroupsPermissions,
        Const.types_action_permissions.createUser,
      );
      this.activateAction.update = this.as.confirmPermission(
        Const.types_permissions.administrationGroupsPermissions,
        Const.types_action_permissions.updateUser,
      );
      if (this.activateAction.update) {
        this.buttons.push({ label: "Modificar", class: "btn-warning", value: "modificar" });
      }
      if (this.activateAction.delete) {
        this.buttons.push({ label: "Eliminar", class: "btn-danger", value: "eliminar" });
      }
      this.buttons.push({ label: "Cancelar", value: "cancelar" });
    } else {
      this.toastr.warning('Usted no posee los permisos necesarios para ver los usuarios del sistema', 'Error en la acción')
    }
  }

  /**
   *Obtiene los cambios en el selector de tipos de usuarios
   *
   * @param {*} data
   * @memberof SystemUsersComponent
   */
  async modelChange(data: any) {
    if (data !== undefined && data.id == 1) {
      this.add();
      //Verificacion tipo de usuario nuevo o existente
      this.isNew = true;
    } else if (data !== undefined && data.id == 2) {
      const configTable = new SystemUsersConfigServcie();
      this.settingsUsers = configTable.getDynamicColumns(this.structureMaster, false, true);
      this.activateFormTable = false;
      this.modificar = false;
      this.actionRow = 'Agregar'
      this.masterTable = 'usuarios';

      //Verificacion tipo de usuario nuevo o existente
      this.isNew = false;

      //Recuperar informacion de usarios con no-login
      this.loading = true;
      const master_users_not_login = await this.suds.getInformacionUserWithoutLoginMasterTable();
      this.loading = false;
      master_users_not_login.valores.sort((a, b) => a.id - b.id);
      this.setTables(master_users_not_login.valores, true, false);
      //Fin
    } else if (data == undefined) {
      this.activateFormTable = false;
    }
  }


  /**
   *Setea la configuracion de la tabla
   *
   * @param {*} data
   * @memberof SystemUsersComponent
   */
  setTables(data: any, not_login: boolean, showLogin: boolean = false) {
    if (this.dynamicMasterTable) {
      if (not_login) {
        const valuesTable: Valores[] = data;
        const usersWithOutLogin: Array<any> = [];
        valuesTable.forEach((col, i) => {
          col.datos["id"] = col.id;
          col.datos["user_login"] = col.user_login;
          if (col.user_login) {
            col.datos["inactivo"] = "No";
          } else {
            col.datos["inactivo"] = "Sí";
            usersWithOutLogin.push(col.datos);
          }
        });
        this.usersNoLogin = new LocalDataSource(usersWithOutLogin);
      } else {
        const valuesTable: Valores[] = data;
        const dataValues: Array<any> = [];
        valuesTable.forEach((col, i) => {
          col.datos["id"] = col.id;
          col.datos["user_login"] = col.user_login;
          if (showLogin) {
            col.datos["_username"] = col.user_login.username;
          }
          if (col.user_login) {
            col.datos["inactivo"] = "No";
            dataValues.push(col.datos);
          } else {
            col.datos["inactivo"] = "Sí";
          }

        });
        this.sourceData = new LocalDataSource(dataValues);
      }

    } else {
      this.sourceData = new LocalDataSource(data);
    }
    this.sourceData.refresh();
  }

  /**
   * Carga cada uno de los labels del selects de los registros de la tabla
   *
   * @private
   * @param {ColumnaMaestra} field
   * @param {InformacionTablaMaestra} [master]
   * @returns {Promise<any>}
   * @memberof TeacherComponent
   */
  private async loadingSelectsTablePrincipal(field: ColumnaMaestra, master?: InformacionTablaMaestra): Promise<any> {
    return new Promise(async (resolve) => {
      if (field.tipo_campo["nombre"] === "ngSelect") {
        let specificEstructure: EstructuraEspecifica;
        let columns: ValoresEspecificos[] = [];
        const filterMaster: FiltroTableMasterGeneral[] = [];

        specificEstructure = {
          maestra: field.maestra_dependencia["id"],
          columnas: [],
          dependencia: [],
        };
        // Se crea la estructura de la consulta de las columnas relacionadas a la maestra para el ngselect
        field.propiedades["columnas_seleccionadas"].forEach((col: string, index: number) => {
          const cols = col.split("_");
          const column = Number(cols[0]);
          if (cols.length === 1) {
            if (typeof field.maestra_dependencia === "object") {
              const structure = find(field.maestra_dependencia.estructura, { id: column });
              if (structure) {
                specificEstructure.columnas.push(column + " ");
              }
            }
          }
        });
        if (field.propiedades["columnas_seleccionadas"].length) {
          const blockColumns: Array<string[]> = [];
          if (field.propiedades["columnas_seleccionadas"]) {
            let columnDependence = "";
            field.propiedades["columnas_seleccionadas"].forEach((col: string, index: number) => {
              const column = col.split("_");
              if (column.length > 1) {
                if (columnDependence !== column[0]) {
                  columnDependence = column[0];
                  const blockColumnsRecolector: Array<string> = [];
                  field.propiedades["columnas_seleccionadas"].forEach((colDep: string, indexDep: number) => {
                    const columnsRef = colDep.split("_");
                    if (columnsRef[0] === columnDependence) {
                      blockColumnsRecolector.push(colDep);
                    }
                  });
                  blockColumns.push(blockColumnsRecolector);
                }
              }
            });
          }
          blockColumns.forEach((columnsSeleted) => {
            const history = this.loadingEstructureColumns(
              field.maestra_dependencia["estructura"],
              columnsSeleted,
              Number(columnsSeleted[0].split("_")[0])
            );

            if (history) {
              specificEstructure.dependencia.push(history);
            }
          });
        }
        // Se setea el valor a mostrar en la columna de la tabla
        if (master && master.valores && master.valores.length) {
          let listIdMaster = "(";
          const idMaster: Array<any> = [];
          const searchValues: Array<{
            id: number;
            data: string;
          }> = [];

          master.valores.forEach((val, index) => {
            if (val.datos[field.id + " "]) {
              const idExist = indexOf(idMaster, val.datos[field.id + " "]);
              if (idExist === -1) {
                if (index && index <= master.valores.length - 1 && listIdMaster !== "(") {
                  listIdMaster += ", ";
                }
                idMaster.push(val.datos[field.id + " "]);
                listIdMaster += val.datos[field.id + " "];
              }
            }
          });
          listIdMaster += ")";
          if (listIdMaster !== "()") {
            columns = await this.suds.getColumnsSpecificMasterTable(specificEstructure, null, listIdMaster);
          }
          await this.asyncForEach(master.valores, async (val: Valores) => {
            let labelSelect = "";
            const search = find(searchValues, { id: val.datos[field.id + " "] });
            if (!search) {
              if (val.datos[field.id + " "]) {
                const column = find(columns, { id: val.datos[field.id + " "] });
                if (column) {
                  field.propiedades["columnas_seleccionadas"].forEach((col: string, index: any) => {
                    if (index > 0) {
                      labelSelect += " / ";
                    }
                    if (column.valores[col]) {
                      labelSelect += column.valores[col];
                    } else {
                      labelSelect += "No aplica";
                    }
                  });

                  searchValues.push({
                    id: column.id,
                    data: labelSelect,
                  });
                }
              }
            } else {
              labelSelect = search.data;
            }
            val.datos[field.id + "_valor"] = labelSelect;
          });
        }
      }
      resolve(true);
    });
  }

  /**
   * Ejecuta un for de forma sincronica
   *
   * @private
   * @param {Array<any>} array
   * @param {*} callback
   * @memberof TeacherComponent
   */
  private async asyncForEach(array: Array<any>, callback: any) {
    for (let index = 0; index < array.length; index++) {
      await callback(array[index], index, array);
      continue;
    }
  }

  /**
   * Realiza la estructura para la consulta de las columnas seleccionadas para mostrar en las tablas y selects
   *
   * @param {ColumnaMaestra[]} structure
   * @param {Array<string>} columns
   * @param {number} [idDependence=0]
   * @returns {EstructuraEspecifica}
   * @memberof TeacherComponent
   */
  loadingEstructureColumns(
    structure: ColumnaMaestra[],
    columns: Array<string>,
    idDependence: number = 0
  ): EstructuraEspecifica {
    let specificEstructure: EstructuraEspecifica;
    const cls: Array<string> = [];
    specificEstructure = {
      maestra: null,
      columnas: [],
      dependencia: [],
    };

    columns.forEach((el) => {
      cls.push(el);
    });

    for (const field of structure) {
      if (field.tipo_campo["nombre"] === "ngSelect") {
        if (idDependence !== 0 && idDependence !== field.id) {
          continue;
        }
        specificEstructure.maestra = field.id + " ";
        cls.forEach((col: string, index: number) => {
          const cols = col.split("_");
          const column = Number(cols[1]);
          if (cols.length === 2) {
            const dependenc = Number(cols[0]);
            if (typeof field.maestra_dependencia === "object") {
              const columnField = find(field.maestra_dependencia.estructura, { id: column });
              if (dependenc === field.id) {
                if (columnField) {
                  specificEstructure.columnas.push(column + " ");
                }
              }
            }
          } else if (cols.length > 2) {
            const cl = cols.slice(1);
            cls[index] = "";
            cl.forEach((el: any, indexCol: number) => {
              cls[index] += el;

              if (indexCol < cl.length - 1) {
                cls[index] += "_";
              }
            });
          }
        });
        if (cls.length) {
          const newLevel = this.loadingEstructureColumns(field.maestra_dependencia["estructura"], cls);
          if (newLevel) {
            specificEstructure.dependencia.push(newLevel);
            break;
          }
        }
      }
    }
    if (specificEstructure.maestra && (specificEstructure.columnas.length || specificEstructure.dependencia.length)) {
      return specificEstructure;
    } else {
      return null;
    }
  }

  /**
   * Esta funcion se ejecuta antes de abrir el formulario para agregar un registro en una de las tablas maestras
   * reinicia las variables principales de la accion modificar configurando todo para proceder a ingresar un registro
   *
   * @param {boolean} [addMaster=false]
   * @memberof TeacherComponent
   */
  add(addMaster: boolean = false) {
    this.modificar = false;
    this.registroSeleccionado = null;
    this.actionMaster = addMaster;
    this.actionRow = "Agregar";
    this.dynamicForm();
  }

  /**
   *Abre la forma para agregar usuarios
   *
   * @memberof SystemUsersComponent
   */
  openForm() {
    if (this.activateAction.createUserSystem) {
      this.formOpen = true;
      this.modifiedUser = false;
      this.actionRow = 'Agregar';
      this.respAction = 'agregar'
    } else {
      this.toastr.warning('Usted no posee permisos necesarios para agregar usuarios del sistema', 'Error en la acción');
    }
    this.getSedes();
  }

  closeForm() {
    this.formOpen = false;
    this.actionRow = '';
    this.modificar = false;
    this.disableSelect = false;
    this.typeUserModel = null;
    this.registroSeleccionado = null;
    this.activateFormTable = false;
    this.userSelected = false;

    this.userName = '';
    this.lastName = '';
  }

  /**
   *Obtiene los cambios al guardar en la forma
   *
   * @param {*} data
   * @memberof SystemUsersComponent
   */
  async sended(data: any) {
    let fInicial = this.datePipe.transform(data.cboFechaInicial, 'yyyy-MM-dd');
    let fFinal = this.datePipe.transform(data.cboFechaFinal, 'yyyy-MM-dd');
    let statePassword = true;
    if (this.respAction == 'agregar') {
      if (this.isNew == false) {
        this.validPassword(data);
        statePassword = this.validPassword(data);
        if (statePassword) {
          if (fInicial > fFinal) {
            this.toastr.warning('La fecha inicial no debe ser mayor a la fecha final')
          } else {
            let user = {
              id_maestra: this.id_maestra,
              tipo_registro: "usuario_existente",
              id_registro: this.userID,
              user_login: {
                username: data.txtUserName,
                is_active: data.chActive,
                sede: data.cboSede,
                cargo: data.cboCharge,
                user_groups: data.cboGroups,
                password: data.password,
                requerie_password: data.chChangePassword,
                fecha_inicial_contrato: fInicial,
                fecha_final_contrato: fFinal,
              }
            }
            await this.suds.createUser(user).then(res => {
              if (res) {
                this.finisAction();
              }
            }, err => {
            })
          }
        }
      } else if (this.isNew == true) {
        this.validPassword(data);
        statePassword = this.validPassword(data);
        if (statePassword) {
          if (fInicial > fFinal) {
            this.toastr.warning('La fecha inicial no debe ser mayor a la fecha final')
          } else {
            let dataResult = {}
            this.structureMaster.forEach(element => {
              dataResult[element.id + " "] = data[element.id + " "]
            });
            const valid = this.validDataForm(dataResult, this.structureMaster)
            if (valid) {
              let newUser = {
                id_maestra: this.id_maestra,
                tipo_registro: "usuario_nuevo",
                datos: dataResult,
                user_login: {
                  username: data.txtUserName,
                  is_active: data.chActive,
                  sede: data.cboSede,
                  cargo: data.cboCharge,
                  user_groups: data.cboGroups,
                  password: data.password,
                  requerie_password: data.chChangePassword,
                  fecha_inicial_contrato: fInicial,
                  fecha_final_contrato: fFinal,
                }
              }

              await this.suds.createUser(newUser).then(res => {
                if (res) {
                  this.finisAction();
                }
              }, err => {
                // console.log(err.error);
              })
            }
          }

        }
      }

    } else if (this.respAction == 'modificar') {
      // a la accion de modificar se le envian los datos nuevos a la api
      if (data.password) {
        statePassword = this.validPassword(data);
        if (statePassword) {
          if (fInicial > fFinal) {
            this.toastr.warning('La fecha inicial no debe ser mayor a la fecha final')
          } else {
            let dataResult = {}
            this.structureMaster.forEach(element => {
              dataResult[element.id + " "] = data[element.id + " "]
            });
            const valid = this.validDataForm(dataResult, this.structureMaster)
            if (valid) {
              let updateUser = {
                id_maestra: this.id_maestra,
                datos: dataResult,
                user_login: {
                  username: data.txtUserName,
                  is_active: data.chActive,
                  sede: data.cboSede,
                  cargo: data.cboCharge,
                  user_groups: data.cboGroups,
                  password: data.password,
                  requerie_password: data.chChangePassword,
                  fecha_inicial_contrato: fInicial,
                  fecha_final_contrato: fFinal,
                }
              }
              await this.suds.updateSelectedUser(this.userID, updateUser).then(async res => {
                if (res) {
                  this.finisAction();
                }
              }, err => {
              });
            }

          }
        }
      } else {
        if (fInicial > fFinal) {
          this.toastr.warning('La fecha inicial no debe ser mayor a la fecha final')
        } else {
          let dataResult = {}
          this.structureMaster.forEach(element => {
            dataResult[element.id + " "] = data[element.id + " "]
          });
          const valid = this.validDataForm(dataResult, this.structureMaster)
          if (valid) {
            let updateUser = {
              id_maestra: this.id_maestra,
              datos: dataResult,
              user_login: {
                username: data.txtUserName,
                is_active: data.chActive,
                sede: data.cboSede,
                cargo: data.cboCharge,
                user_groups: data.cboGroups,
                requerie_password: data.chChangePassword,
                fecha_inicial_contrato: fInicial,
                fecha_final_contrato: fFinal,
              }
            }

            await this.suds.updateSelectedUser(this.userID, updateUser).then(async res => {
              if (res) {
                this.finisAction();
              }
            }, err => {
            });
          }
        }
      }

    }
  }

  finisAction() {
    //Reiniciar la consulta/ setear valores a la tabla
    this.startConsulting();
    this.formOpen = false;
    this.controls = [];
    this.typeUserModel = null;
    this.activateFormTable = false;
  }

  /**
   *Setea los campos para llenar según las columnas de la tabla
   *
   * @private
   * @memberof SystemUsersComponent
   */
  private async dynamicForm() {
    let objectModel: any;
    if (this.modificar) {
      objectModel = this.registroSeleccionado;
      this.claseButton = 'btn-warning';
      this.textoButton = 'Modificar';
    } else {
      this.claseButton = 'btn-success';
      this.textoButton = 'Agregar';
    }
    if (!this.actionMaster) {
      if (this.opcion !== "") {
        this.tableSelect = find(this.tablesMaster, { nombre: this.opcion });
        if (this.tableSelect) {
          await this.asyncForEach(this.structureMaster, async (field: ColumnaMaestra) => {
            await this.loadingSelectsOptions(field, objectModel);
          });
          this.masterTable = this.tableSelect.nombre;
          this.formOpen = true;
        } else {
          this.masterTable = "";
          this.formOpen = false;
        }
      }
    } else {
      this.formOpen = true;
      if (this.modificar) {
        objectModel = this.registroSeleccionado;
        this.claseButton = 'btn-warning';
        this.textoButton = 'Modificar';
      } else {
        this.claseButton = 'btn-success';
        this.textoButton = 'Agregar';
      }
      this.controls = this.sufs.getFieldsDynamicTable(objectModel);

      this.masterTable = "Maestra";
      if (this.registroSeleccionado) {
        this.masterTable += " " + this.registroSeleccionado.nombre;
      }
    }
  }

  /**
   *Carga las opciones de los selectores
   *
   * @private
   * @param {ColumnaMaestra} field
   * @param {*} [data]
   * @param {boolean} [refreshForm=true]
   * @return {*}  {Promise<any>}
   * @memberof SystemUsersComponent
   */
  private async loadingSelectsOptions(field: ColumnaMaestra, data?: any, refreshForm: boolean = true): Promise<any> {
    return new Promise(async (resolve) => {
      this.name = '';
      if (field.tipo_campo["nombre"] === "ngSelect") {
        const columnsMaster: Array<{
          key: string;
          value: number;
        }> = [];
        let specificEstructure: EstructuraEspecifica;
        let columns: ValoresEspecificos[] = [];
        const filterMaster: FiltroTableMasterGeneral[] = [];

        specificEstructure = {
          maestra: field.maestra_dependencia["id"],
          columnas: [],
          dependencia: [],
        };
        // Se crea la estructura de la consulta de las columnas relacionadas a la maestra para el ngselect
        field.propiedades["columnas_seleccionadas"].forEach((col: string, index: number) => {
          const cols = col.split("_");
          const column = Number(cols[0]);
          if (cols.length === 1) {
            if (typeof field.maestra_dependencia === "object") {
              const structure = find(field.maestra_dependencia.estructura, { id: column });

              if (structure) {
                // field.propiedades['columnas_seleccionadas'].slice(index, 1);
                specificEstructure.columnas.push(column + " ");
              }
            }
          }
        });
        if (field.propiedades["columnas_seleccionadas"].length) {
          const blockColumns: Array<string[]> = [];
          if (field.propiedades["columnas_seleccionadas"]) {
            let columnDependence = "";
            field.propiedades["columnas_seleccionadas"].forEach((col: string, index: number) => {
              const column = col.split("_");
              if (column.length > 1) {
                if (columnDependence !== column[0]) {
                  columnDependence = column[0];
                  const blockColumnsRecolector: Array<string> = [];
                  field.propiedades["columnas_seleccionadas"].forEach((colDep: string, indexDep: number) => {
                    const columnsRef = colDep.split("_");
                    if (columnsRef[0] === columnDependence) {
                      blockColumnsRecolector.push(colDep);
                    }
                  });
                  blockColumns.push(blockColumnsRecolector);
                }
              }
            });
          }
          blockColumns.forEach((columnsSeleted) => {
            const history = this.loadingEstructureColumns(
              field.maestra_dependencia["estructura"],
              columnsSeleted,
              Number(columnsSeleted[0].split("_")[0])
            );

            if (history) {
              specificEstructure.dependencia.push(history);
            }
          });
        }
        if (field.validaciones && field.validaciones.filtros && field.validaciones.filtros.length) {
          field.validaciones.filtros.forEach((filter) => {
            if (filter.columna) {
              let valorField: any;
              if (filter.field) {
                const control = find(this.structureMaster, { alias: filter.field });
                if (control) {
                  if (data) {
                    valorField = data[control.id + " "];
                  } else {
                    if (this.currentForm) {

                      valorField = this.currentForm.controls[control.id + " "].value;
                    }
                  }
                }
              } else {
                valorField = filter.valor;
              }
              if (!valorField) {
                valorField = "";
              }

              if (filter.operador && (filter.operador === "LIKE" || filter.operador === "ILIKE")) {
                valorField = "%" + valorField + "%";
              }

              const cols = filter.columna.split("_");
              if (cols.length && cols.length > 1) {
                if (filter.condicional) {
                  filterMaster.push({
                    maestra: cols[cols.length - 2],
                    columna: cols[cols.length - 1],
                    valor: valorField,
                    operador: filter.operador ? filter.operador : "=",
                    condicional: filter.condicional,
                  });
                } else {
                  filterMaster.push({
                    maestra: cols[cols.length - 2],
                    columna: cols[cols.length - 1],
                    valor: valorField,
                    operador: filter.operador ? filter.operador : "=",
                  });
                }
              } else {
                if (filter.condicional) {
                  filterMaster.push({
                    columna: cols[cols.length - 1],
                    valor: valorField,
                    operador: filter.operador ? filter.operador : "=",
                    condicional: filter.condicional,
                  });
                } else {
                  filterMaster.push({
                    columna: cols[cols.length - 1],
                    valor: valorField,
                    operador: filter.operador ? filter.operador : "=",
                  });
                }
              }
            }
          });
        }
        let validSearch = false;
        if (filterMaster.length === 1) {
          if (filterMaster[0].operador === "IS NULL" || filterMaster[0].operador === "IS NOT NULL") {
            validSearch = true;
          } else {
            if (filterMaster[0].valor) {
              validSearch = true;
            }
          }
        } else if (filterMaster.length > 1) {
          validSearch = true;
        } else if (!filterMaster.length) {
          validSearch = true;
        }
        if (validSearch) {
          columns = await this.suds.getColumnsSpecificMasterTable(specificEstructure, filterMaster);
        }
        // se setean los labels a mostrar en el select
        columns.forEach((column) => {
          let labelSelect = "";
          field.propiedades["columnas_seleccionadas"].forEach((col: string, index: any) => {
            if (index > 0) {
              labelSelect += " / ";
            }
            if (column.valores[col]) {
              labelSelect += column.valores[col];
            } else {
              labelSelect += "No aplica";
            }
          });
          columnsMaster.push({ value: column.id, key: labelSelect });
        });
        if (field.propiedades["tipoSelector"] && field.propiedades["tipoSelector"] === "EnModal") {
          const dataModalSelector: Array<any> = [];
          columns.forEach((row) => {
            const d = Static.copyObjet(row.valores);
            d["id"] = row.id;
            dataModalSelector.push(d);
          });
          field.propiedades["dataSelectorModal"] = dataModalSelector;
        }
        field.propiedades["options"] = columnsMaster;
      }
      if (refreshForm) {
        if (this.generateUserLogin) {
          let req = true;
          let deactiveUserName = this.generateUserLogin;
          if (this.respAction == 'modificar') {
            req = false;
            deactiveUserName = true;
          }
          this.controls = this.sufs.getFieldsDynamicTableStructure(
            this.structureMaster,
            this.templatesFomr,
            data,
            false,
            this.options,
            req,
            this.name,
            deactiveUserName
          );
        } else {
          let req = true;
          if (this.respAction == 'modificar') {
            req = false;
          }
          this.controls = this.sufs.getFieldsDynamicTableStructure(
            this.structureMaster,
            this.templatesFomr,
            data,
            false,
            this.options,
            req,
          );
        }

        const ctrl = find(this.controls[0]["controls"], { key: field.id + " " });
        if (ctrl) {
          if (this.currentForm && this.currentForm.controls[field.id + " "]) {
            this.currentForm.controls[field.id + " "].setValue(ctrl["value"]);
          }
        }
      }

      resolve(true);
    });
  }

  /**
   *Obtiene la acción de click sobre la tabla del agregar
   *
   * @param {*} data
   * @memberof SystemUsersComponent
   */
  onTableFormClick(data: any) {
    this.userID = data.data.id
    this.userSelected = true;
    this.activateFormTable = false;

    // Obtiene el nombre y apellidos para el login automatico
    let structureUserName = find(this.structureMaster, { alias: 'txtNombre' })
    let structurelastName = find(this.structureMaster, { alias: 'txtApellidosUsuario' })
    this.userName = data.data[structureUserName.id + " "];
    this.lastName = data.data[structurelastName.id + " "];

    let userLogin = {
      "ind_nombre": this.userName,
      "ind_apellido": this.lastName
    }
    if (this.generateUserLogin) {
      this.suds.automaticLogin(userLogin).subscribe(async resp => {
        this.name = await resp['user_name'];

        // Pasamos esta accion dentro para que espere el user_name y lo setee en el control
        let req = true;
        if (this.respAction == 'modificar') {
          req = false;
        }

        this.controls = this.sufs.getFieldsDynamicTableStructure(
          this.structureMaster,
          this.templatesFomr,
          data,
          true,
          this.options,
          req,
          this.name,
          this.generateUserLogin
        );
      })
    }
    // FIN

    else {
      let req = true;
      if (this.respAction == 'modificar') {
        req = false;
      }

      this.controls = this.sufs.getFieldsDynamicTableStructure(
        this.structureMaster,
        this.templatesFomr,
        data,
        true,
        this.options,
        req,
        this.name,
        this.generateUserLogin
      );
    }

  }

  /**
   *Habilita el formulario de login
   *
   * @memberof SystemUsersComponent
   */
  openLoginForm() {
    // Se le asigna al boton el texto y la clase que tendrá
    this.claseButton = 'btn-success';
    this.textoButton = 'Agregar';

    this.userSelected = false;
    this.activateFormTable = true;
  }

  /**
   *define el mensaje ha mostrar y abre el modal de la tabla
   *
   * @private
   * @memberof SystemUsersComponent
   */
  private openModalTable() {
    this.questionTable = "";
    this.questionTable = "¿Que accion desea realizar?";
    this.modalTable.openModal();
  }

  /**
   *Esta funcion controla el evento al dar click en un registro de la tabla
   *
   * @param {*} data
   * @memberof SystemUsersComponent
   */
  onCellClick(data: any) {
    this.userID = data.data.id;
    if (data) {
      this.actionMaster = false;
      this.registroSeleccionado = data.data;
      this.modificar = true;
      this.actionRow = "Modificar";
      this.openModalTable();
    } else {
      this.toastr.error(
        "Usted no posee permisos de modificar o eliminar los registro de las tablas maestras",
        "Permiso denegado"
      );
    }
  }

  /**
   *Controla la respuesta del modal de la tabla
   *
   * @param {String} res
   * @memberof SystemUsersComponent
   */
  async modalTableAction(res: String) {
    this.getSedes();
    this.respAction = res;
    switch (res) {
      case "modificar":
        this.dynamicForm();
        this.disableSelect = true;
        this.modifiedUser = true;
        break;
      case "login":
        // this.userLogin.idRegistration = this.registroSeleccionado["id"];
        // if (this.registroSeleccionado["user_login"]) {
        //   this.userLogin.userLogin = this.registroSeleccionado["user_login"];
        // } else {
        //   this.userLogin.userLogin = null;
        // }
        // this.userLogin.open();
        break;
      case "eliminar":
        // this.confirm();
        await this.suds.deleteSelectedUser(this.userID);
        this.startConsulting();
        break;
    }
  }


  /**
   * Anexa al selector de cargos los valores para el selecctor
   */
  getSedes() {
    if (this.optSedes && this.optSedes.length) {
      this.optSedes = [];
    }
    this.suds.getSedes(this.optCompanies[0].value).subscribe((data) => {
      if (data && data.length) {
        data.sort((a, b) => a.id - b.id);
        data.forEach((rol) => {
          this.optSedes.push({
            value: rol.id,
            key: rol.nombre,
          });
        });
        this.options["optSedes"] = this.optSedes;
      }
    });
  }

  /**
   * Requerimiento login automatico
   */
  async onChangeControls(data: any) {
    // Verificación de agregar o modificar usuario
    if (this.generateUserLogin) {
      let valid_info = false
      let structureUserName = await find(this.structureMaster, { alias: 'txtNombre' })
      let structurelastName = await find(this.structureMaster, { alias: 'txtApellidosUsuario' })
      if (this.modifiedUser == true) {
        if (data.controlChanged == structureUserName.id + " ") {
          if (this.userName != data.change[structureUserName.id + " "])
            this.userName = data.change[structureUserName.id + " "];
          valid_info = true;
        }
        if (data.controlChanged == structurelastName.id + " ") {
          if (this.lastName != data.change[structurelastName.id + " "]) {
            this.lastName = data.change[structurelastName.id + " "];
            valid_info = true;
          }

        }
        if (valid_info == true) {
          let userLogin = {
            "ind_nombre": this.registroSeleccionado[structureUserName.id + " "],
            "ind_apellido": this.registroSeleccionado[structurelastName.id + " "]
          }
          this.suds.automaticLogin(userLogin).subscribe(user => {
            data.form.controls.txtUserName.setValue(user['user_name']);
            this.modifiedUser = false;
          })
        }
      } else {
        // Entra en agregar usuario y verifica que sea nuevo
        if (this.isNew == true) {
          if (data.controlChanged == structureUserName.id + " ") {
            if (this.userName != data.change[structureUserName.id + " "])
              this.userName = data.change[structureUserName.id + " "];
            valid_info = true;
          }
          if (data.controlChanged == structurelastName.id + " ") {
            if (this.lastName != data.change[structurelastName.id + " "]) {
              this.lastName = data.change[structurelastName.id + " "];
              valid_info = true;
            }

          }

          // Verifica variable de entorno
          if (this.generateUserLogin && valid_info) {
            data.form.controls.txtUserName.setValue('');
            // Consulta para persona natural
            if (this.userName != '' && this.userName != undefined && this.lastName != undefined && this.lastName != '') {
              let userLogin = {
                "ind_nombre": this.userName,
                "ind_apellido": this.lastName
              }
              this.suds.automaticLogin(userLogin).subscribe(user => {
                data.form.controls.txtUserName.setValue(user['user_name']);
              })
            }
            // consulta persona no natural
            else if (this.userName && (this.lastName == '' || this.lastName == undefined)) { // consulta para persona juridica con apellido vacio
              let userLogin = {
                "ind_nombre": this.userName,
                "ind_apellido": ''
              }
              this.suds.automaticLogin(userLogin).subscribe(user => {
                data.form.controls.txtUserName.setValue(user['user_name']);
              })
            }
          }
        }
      }

    }
  }

  /**
   * Validacion de password
   */
  validPassword(data: any) {
    let valid = true;
    if ((data.password || data.passConfirmation) && data.password !== data.passConfirmation) {
      valid = false;
      this.toastr.warning('Las contraseñas no coinciden, verifica e intentalo de nuevo');
    }
    return valid;
  }

  /**
   * Validad la informacion a guardar de la maestra
   *
   * @private
   * @param {*} data
   * @param {ColumnaMaestra[]} form
   * @returns {boolean}
   * @memberof TeacherComponent
   */
  private validDataForm(data: any, form: ColumnaMaestra[]): boolean {
    let valid = true;
    if (form.length) {
      const formulario = this.currentForm;
      for (const field of form) {
        if (typeof field.tipo_campo === 'object' && field.tipo_campo.nombre === 'number') {
          if (data[field.id + ' '] !== undefined) {
            data[field.id + ' '] = Number(data[field.id + ' ']);
          }
        } else if (typeof field.tipo_campo === 'object' && field.tipo_campo.nombre === 'checkbox') {
          if (data[field.id + ' '] !== undefined) {
            if (
              typeof data[field.id + ' '] !== 'boolean' &&
              (data[field.id + ' '] === 'true' || data[field.id + ' '] === 'false')
            ) {
              switch (data[field.id + ' ']) {
                case 'true':
                  data[field.id + ' '] = true;
                  break;
                default:
                  data[field.id + ' '] = false;
                  break;
              }
            } else {
              data[field.id + ' '] = false;
            }
          } else {
            data[field.id + ' '] = false;
          }
        }
        const hiddenField = this.getHiddenField(this.controls, String(field.id) + ' ');
        if (data[field.id + ' '] === undefined || hiddenField === 1 || hiddenField === -1) {
          if (data[field.id + ' '] === undefined) {
            if (typeof field.tipo_campo === 'object' && field.tipo_campo.nombre === 'checkbox') {
              if (formulario.controls[field.id + ' '].value) {
                data[field.id + ' '] = formulario && formulario.controls[field.id + ' '].value;
              } else {
                data[field.id + ' '] = false;
              }
            }
          }
          continue;
        } else {
          if (typeof field.tipo_campo === 'object' && field.tipo_campo.nombre === 'checkbox') {
            if (field.requerido && !formulario.controls[field.id + ' '].disabled) {
              if (!data[field.id + ' ']) {
                this.toastr.warning(
                  'Hay campos requeridos sin llenar, verifique e inténtelo de nuevo',
                  'Información incompleta', {
                  positionClass: 'toast-top-center'
                }
                );
                formulario.controls[field.id + ' '].setValue(null);
                valid = false;
                break;
              }
            }
          }
        }
      }
    }
    return valid;
  }

  /**
   * Consulta si un campo dentro de un formulario esta oculto
   * 1 = Si
   * 0 = No
   * -1 = Campo no encontrado
   *
   * @private
   * @param {Array<BaseControl<Partial>>} form
   * @param {string} nameField
   * @returns {number}
   * @memberof TeacherComponent
   */
  private getHiddenField(
    form: Array<BaseControl<Partial>>,
    nameField: string
  ): number {
    let hidden = -1;
    form.forEach(field => {
      if (field.controlType !== 'container') {
        if (field.key === nameField) {
          if (field.hiddenCondiction) {
            hidden = 1;
          } else {
            hidden = 0;
          }
        }
      } else {
        hidden = this.getHiddenField(field['controls'], nameField);
      }
    });
    return hidden;
  }
}






// WEBPACK FOOTER //
// ./src/app/administration/groups-permissions/system-users/system-users.component.ts